<template>
  <div class="h-full relative mt-14  bg-gray-200 overflow-y-none    h-full">
    <PDFNavBar
      :name="name"
      :reference="reference"
      :version="version"
      :loading="!showPDF"
      :status="status"
      :profile="profile"
      :source="source2"
      mode="view"
      @download="onDownload"
      @publish="onPublish"
      @change="onChangeType"
      @view="OnView"
      @back="OnBack"
      @previous="OnPrevious"
      @next="OnNext"
    />
    <div class="w-full h-full">
      <div
        v-if="!showPDF"
        class="flex items-center justify-center px-16 py-6 bg-gray-500 h-screen w-full"
      >
        <svg
          aria-hidden="true"
          class="w-8 h-8 mr-2 text-gray-200 animate-spin  fill-blue-600"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>

        <span class="text-2xl text-white">Chargement en cours, Merci de patienter...</span>
      </div>

      <div
        v-if="showPDF"
        class="px-16 py-6 bg-gray-200 border border-color-gray-700 w-full "
      >
        <div
          :class=" {'hidden' : (viewBy==1), 'show' : (viewBy==2)}"
          class=" flex flex-row items-center justify-between "
        >
          <vue-pdf-embed
            ref="pdfRef1"
            :width="pdf_w"
            class="h-full"
            :source="source2"
            :page="page"
          />
          <vue-pdf-embed
            ref="pdfRef2"
            :width="pdf_w"
            class="h-full"
            :source="source2"
            :page="page2"
          />
        </div>

        <div
          :class=" {'hidden' : (viewBy==2), 'show' : (viewBy==2)}"
          class="flex flex-row items-center justify-between h-full"
        >
          <vue-pdf-embed
            ref="pdfRef3"
            class="w-full"
            :source="source2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import service from "@/services/FullService.vue"
  import PDFNavBar from "@/components/PDFNav.vue"
  import { mapGetters } from "vuex";
  import VuePdfEmbed from 'vue-pdf-embed'
  export default {

    name: "DocumentDisplayView",
    components: {
      //GoogleMap, Marker,
      PDFNavBar,
      VuePdfEmbed,
    },


    props:
    {
      title: String,
      subTitle: String
    },
    data() {

      return {
        viewBy: 1,
        showPDF: false,
        profile: "EU-fr",
        page: 1,
        page2: 2,
        pdf_w: "650",
        reference: "",
        name: "",
        version: "",
        source2: "",
        status: "",
        newTS: null,
        record: {},
        response: [],
        labels: [],
      }
    },

    computed:
    {
      ...mapGetters({ user: "StateUser" }),
      mapRef: function (a) {
        if (a == undefined) return null;
        return a;
      }
    },

    watch: {
      'user.tenant_id': async function () {



      }
    },

    mounted: async function () {


      if (this.user == undefined) {
        //this.$router.push("/login");
        window.location = "/login"
        return;
      }






      //   let product = await service.getDataId("products", this.$route.params.id, this.user?.token)


      let pdf = await service.getDataId("technical-sheets", this.$route.params.id, this.user?.token, { fields: 'id,name,market,langage,data' })
      // let pdf = await service.getDataId("technical-sheets/generate", this.$route.params.id, this.user?.token, { market: market, langage: langage })

      //  let pdf = await service.generatePDF( this.$route.params.id, this.user?.token, { market: market, langage: langage })


      this.record = pdf;
      if (pdf == null) {
        alert("Error Generaiton PDF")
      }
      else {


        this.profile = pdf.market.toUpperCase() + "-" + pdf.langage.toUpperCase()


        this.name = pdf.product.name;
        this.reference = pdf.product.name;
        this.newTS = pdf.technicalSheet;
        this.source2 = pdf?.data;

        this.version = pdf.version;

        this.status = pdf.status;
      }

      this.showPDF = true;

      this.$nextTick(function () {
        window.scrollTo(0, 0)
      });
    },


    methods:
    {


      loadPdf: async function (id) {

        if (this.user == undefined) {
          //this.$router.push("/login");
          window.location = "/login"
          return;
        }
        this.showPDF = false;
        let pdf = await service.getDataId("technical-sheets", id, this.user?.token, { fields: 'id,name,market,langage,data' })

        this.record = pdf;
        if (pdf == null) {
          alert("Error load PDF = ", id)
        }
        else {


          this.profile = pdf.market.toUpperCase() + "-" + pdf.langage.toUpperCase()


          this.name = pdf.product.name;
          this.reference = pdf.product.name;
          this.newTS = pdf.technicalSheet;
          this.source2 = pdf?.data;

          this.version = pdf.version;

          this.status = pdf.status;
        }

        this.showPDF = true;

        this.$nextTick(function () {
          window.scrollTo(0, 0)
        });
      },

      OnNext: async function () {
        await this.loadPdf(this.$route.params.id)
      },
      OnPrevious: async function () {
        await this.loadPdf(this.$route.params.id)
      },
      onChangeType: async function (/*profile*/) {


      },
      OnView: function (v) {
        this.viewBy = v


        this.$nextTick(() => {
          if (v == 2) {

            this.$refs.pdfRef1.render()
            this.$refs.pdfRef2.render()
          }
        });


      },
      onPublish: async function () {
        let response = await service.getDataId("technical-sheets/publish", this.newTS, this.user?.token)

        if (response.id != null) {

          this.record.status = "PUBLISHED"
          this.status = "PUBLISHED"
        }

        //    this.$router.go(-1)
      },

      OnBack: function () {
        this.$router.go(-1)
      },
      onDownload: function () {

        this.downloadPDF(this.record.data, "FT-" + this.record.product.reference + "-" + this.profile + ".pdf")
      },
      downloadPDF: function (base64, filename) {

        // Create an anchor element
        var link = document.createElement("a");
        link.href = base64;
        link.download = filename;
        document.body.appendChild(link);
        // Click the link
        link.click();
        // Remove the link
        document.body.removeChild(link);
      }

    },



  };
</script>


<style>
  .vue-pdf-embed>div {
    margin-bottom: 8px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
  }
</style>